<div class="w-100 ap-mb-spacing-5">
  <gstar-combobox
    [label]="'admin.dashboard.residencyJurisdictionsTitle' | translate"
    [options]="resJurisdictions()"
    [required]="required"
    keyProp="name"
    valueProp="residencyJurisdictionId"
    trackByKey="residencyJurisdictionId"
    [value]="value"
    [disabled]="disabled"
    (selectItem)="selectResidencyJurisdictionHandler($event)" />
</div>
